import { useEffect, useRef } from 'react';
import { AlertIcon } from '@onchainstudios/cryptoys-common-ui';
import styles from './ErrorMessageBlock.module.css';

function ErrorMessageBlock({
  message = 'Sorry, we couldn’t verify your payment information. Please try again.'
}) {
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    element.firstChild.classList.remove('hidden');
  }, [elementRef]);

  return (
    <div
      role="alert"
      className={styles.errorMessageBlock}
      ref={elementRef}
      id="expirationWarning"
    >
      <div className={styles.errorMessageIcon}>
        <AlertIcon size="l"></AlertIcon>
      </div>
      <p className={styles.errorMessageCopy}>{message}</p>
    </div>
  );
}

export default ErrorMessageBlock;
